






























































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  RimRepairLayoutComponent,
  RimRepairLoadingComponent,
  RimRepairCardComponent,
  RimRepairModalComponent,
	RimRepairTransferComponent,
	WorkOrderFilterComponent
} from "@/components/common";

import { IWorkOrderCard, IWhoAmI, IWorkOrderFilter, IStaff } from "@/interfaces";
import { GetWorkOrders } from "@/api";
import { Getter } from "vuex-class";
import { makeWorkOrderFilter } from "@/utils";

@Component({
  components: {
    RimRepairLayoutComponent,
    RimRepairLoadingComponent,
    RimRepairCardComponent,
    RimRepairModalComponent,
		RimRepairTransferComponent,
		WorkOrderFilterComponent
  }
})
export default class TechnicianComponent extends Vue {
  @Getter("staffWithMe", { namespace: "AppModule" })
  public staff!: IWhoAmI;
  @Getter("loading", { namespace: "AppModule" })
  public loadLoading!: boolean;
  public workOrders: IWorkOrderCard[] = [];
  public loading = false;
  public dialog = false;
  public selectedWorkOrderCard: IWorkOrderCard | null = null;
	public filter: IWorkOrderFilter = makeWorkOrderFilter({});



  mounted() {
    this.getWorkOrders();
  }

	public BeginFiltering():void{
		this.getWorkOrders();
	}


  async getWorkOrders() {

    try {
      this.loading = true;
      const resp = await GetWorkOrders(this.filter);
      if (resp.Ok) {
        this.workOrders = resp.WorkOrders;
      }
      this.loading = false;
    } catch (err) {
      //
    }
  }

  goToEditWorkOrder(workOrderCard: IWorkOrderCard) {
    this.$router.push(
      `technician/work-order/edit/${workOrderCard.RecordID}/${workOrderCard.CustID}`
    );
  }

  closeSuccess() {
    this.dialog = false;
    this.getWorkOrders();
  }

  transfer(workOrderCard: IWorkOrderCard) {
    this.selectedWorkOrderCard = workOrderCard;
    this.dialog = true;
  }
}
